import { render } from "./EmployeeEdit.vue?vue&type=template&id=2b001d6f&scoped=true"
import script from "./EmployeeEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeEdit.vue?vue&type=script&lang=js"

import "./EmployeeEdit.vue?vue&type=style&index=0&id=2b001d6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b001d6f"]])

export default __exports__